import { render, staticRenderFns } from "./SidebarDesktop.vue?vue&type=template&id=0b4f3d8c&"
import script from "./SidebarDesktop.vue?vue&type=script&lang=js&"
export * from "./SidebarDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports